export default __webpack_public_path__ + "static/media/83@2x-8.950babb0.png";